export function isAutoFontSize(fontSize) {
  return typeof fontSize === 'string' && fontSize.trim().toLowerCase() === 'auto';
}

export function getManualFontSizeStyle(fontSize) {
  if (!fontSize || isAutoFontSize(fontSize)) {
    return {};
  }
  return { fontSize };
}

export const AUTO_FONT_SIZE_MIN_EM = 0.25;
export const AUTO_FONT_SIZE_MAX_EM = 1;
export const AUTO_FONT_SIZE_MAX_EM_CURRENT = 0.8;
